import React, { useEffect } from 'react';
import { useIsDesktop } from '../../hooks/useMediaQuery';
import { useAuth } from '../../contexts/AuthContext';
import { useWouterRouter } from '../../hooks/useWouterNavigation';
import { WhyJoinUsContent } from '../../components/auth/WhyJoinUs';
import { Icon } from '../DesignSystem/primitives/Icon';
import LogoSVG from '../DesignSystem/primitives/LogoSVG';
import LoginPage from '../LoginPage/LoginPage';
import RegisterPage from '../RegisterPage/RegisterPage';
import './AuthPage.css';

interface AuthPageProps {
  mode: 'login' | 'register';
}

export const AuthPage: React.FC<AuthPageProps> = ({ mode }) => {
  const isDesktop = useIsDesktop();
  const { user } = useAuth();
  const { navigate } = useWouterRouter();

  // Redirect if already authenticated
  useEffect(() => {
    if (user) {
      navigate('/organizer');
    }
  }, [user, navigate]);

  // Don't render if already authenticated
  if (user) {
    return null;
  }

  return (
    <div className={`auth-page ${isDesktop ? 'auth-page--desktop' : 'auth-page--mobile'}`}>
      {/* Large monkey background decoration */}
      {isDesktop && (
        <div className="auth-page__monkey-bg">
          <LogoSVG variant="singeVert" size="xl" />
        </div>
      )}
      {isDesktop ? (
        <>
          {/* Desktop: Split layout 50/50 */}
          <div className="auth-page__why-join">
            <WhyJoinUsContent variant="full" />
          </div>
          <div className="auth-page__form">
            <div className="auth-page__form-wrapper">
              {mode === 'login' ? (
                <LoginPage embedded />
              ) : (
                <RegisterPage embedded />
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          {/* Mobile: Form first, then full content below */}
          <div className="auth-page__form">
            <div className="auth-page__form-wrapper">
              {mode === 'login' ? (
                <LoginPage embedded />
              ) : (
                <RegisterPage embedded />
              )}
            </div>
          </div>
          {/* Scroll indicator badge */}
          <div className="auth-page__scroll-badge">
            <span>Discover why organizers love us</span>
            <Icon name="ChevronDown" size={16} />
          </div>
          <div className="auth-page__why-join-mobile">
            <WhyJoinUsContent variant="full" />
          </div>
        </>
      )}
    </div>
  );
};

export default AuthPage;
